var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{class:{ 'blocked-link': !_vm.href },attrs:{"href":_vm.href}},[(_vm.icon)?_c('v-list-item-icon',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1):_vm._e(),_c('v-list-item-title',[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }